var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-band",style:([{backgroundColor: !_vm.color || _vm.color === '' ? '#754cf5' : _vm.color}])})
}
var staticRenderFns = []

export { render, staticRenderFns }